import React from "react"

class AgeRangeDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.maximum_age == null || typeof this.props.row.maximum_age == 'undefined') {
	    return (
	      <div>{this.props.row.minimum_age}+</div>
	  	);
  	} else {
  		return (
  			<div>{this.props.row.minimum_age} &ndash; {this.props.row.maximum_age}</div>
  		);
  	}
  }

};

export default AgeRangeDataType